var _title, _desc, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReviewRequestActive = function SvgReviewRequestActive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "22px",
    viewBox: "0 0 19 22",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic-hand_pointer")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gosite-SVG-Icons",
    transform: "translate(-570.000000, -362.000000)",
    stroke: "#0A1E3B",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.126587,364.709225 L576.126587,373.389649 C576.126587,373.941933 575.678872,374.389649 575.126587,374.389649 C575.090573,374.389649 575.054586,374.387703 575.018782,374.383821 L572.194547,374.077571 C571.645481,374.018032 571.152109,374.414872 571.09257,374.963938 C571.086004,375.024489 571.084984,375.085512 571.089522,375.146248 L571.156125,376.037705 C571.183244,376.401326 571.406166,376.721338 571.737833,376.872839 C573.9778,377.89603 575.498367,378.694013 576.299534,379.26679 C577.27097,379.961298 578.03737,380.915561 578.598732,382.129578 C578.844146,382.660261 579.375543,383 579.960224,383 L585.259888,383 C586.364457,383 587.259888,382.104569 587.259888,381 L587.259888,375.146348 C587.259901,374.691966 587.105178,374.251127 586.821205,373.896411 C586.02129,372.897224 584.950802,372.078174 583.609741,371.43926 C582.909458,371.105628 581.794119,370.73631 580.263726,370.331306 C579.825052,370.215244 579.519531,369.818352 579.519531,369.364585 L579.519531,364.886661 C579.519534,364.688978 579.490225,364.492386 579.432565,364.303298 C579.167612,363.434433 578.635362,363 577.835815,363 C577.835815,363 577.835815,363 577.835815,363 C576.891837,363 576.126591,363.765246 576.126587,364.709225 Z",
    id: "ic-hand_pointer"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReviewRequestActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/review-request-active.11b44152.svg";
export { ForwardRef as ReactComponent };